import type { AdminUsersResponseDto } from 'app/API';

type TParams = {
  users: AdminUsersResponseDto;
  uid: string;
  role: string;
  value: boolean;
};

export const updateAdminUserRoles = ({ users, uid, role, value }: TParams): AdminUsersResponseDto => ({
  ...users,
  data: users.data.map((user) => {
    if (user.id !== uid) {
      return user;
    }

    const roles = value
      ? user.roles.includes(role)
        ? user.roles
        : [...user.roles, role]
      : user.roles.filter((currentRole) => currentRole !== role);

    return { ...user, roles };
  }),
});
